(() => {
  if (window.otcClickMenuReady) return;
  window.otcClickMenuReady = true;
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const summary = target.closest('.otc-menu-parent > summary');
    if (summary) {
      const parent = summary.parentElement;
      parent.closest('.otc-menu-root')?.querySelectorAll(':scope > li > details[open]').forEach(other => {
        if (other !== parent) other.open = false;
      });
    }
    document.querySelectorAll('.otc-click-nav--desktop .otc-menu-parent[open]').forEach(details => {
      if (!details.contains(target)) details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    const details = target.closest('.otc-click-nav details[open]');
    if (details) {
      event.stopPropagation();
      details.open = false;
      details.querySelector(':scope > summary')?.focus();
    }
  });
})();
